import { arrayValue, isArray } from '../packages/array.js';
import { registryContract } from '@hephesapla/registry-contract';
import type { RegistryShape } from '../../source/shared/pilot-registry-types.js';

function matches(value: unknown, shape: RegistryShape): boolean {
    switch (shape.kind) {
        case 'reference': {
            const definition = registryContract.definitions[shape.name];
            if (!definition) throw new Error('Registry tip sözleşmesi eksik: ' + shape.name);
            return matches(value, definition);
        }
        case 'union': return shape.members.some(member => matches(value, member));
        case 'literal': return value === shape.value;
        case 'null': return value === null;
        case 'json': {
            const entries = arrayValue(value);
            return value === null || typeof value === 'string' || typeof value === 'boolean'
            || (typeof value === 'number' && Number.isFinite(value))
            || (entries !== null && Array.from(entries).every((item: unknown) => matches(item, shape)))
            || (!!value && typeof value === 'object' && !isArray(value) && Object.values(value).every((item: unknown) => matches(item, shape)));
        }
        case 'number': return typeof value === 'number' && Number.isFinite(value);
        case 'string': return typeof value === 'string';
        case 'boolean': return typeof value === 'boolean';
        case 'array': {
            const entries = arrayValue(value);
            return entries !== null && Array.from(entries).every((item: unknown) => matches(item, shape.item));
        }
        case 'tuple': {
            const entries = arrayValue(value);
            return entries !== null && entries.length === shape.items.length
                && shape.items.every((item, index) => matches(entries[index], item));
        }
        case 'object': {
            if (!value || typeof value !== 'object' || isArray(value)) return false;
            const fields: Readonly<Record<string, unknown>> = Object.fromEntries(Object.entries(value));
            return Object.entries(shape.fields).every(([key, field]) => shape.optional.includes(key) && !(key in fields)
                || key in fields && matches(fields[key], field));
        }
    }
}

export function assertRegistryContract(value: unknown): void {
    if (!matches(value, registryContract.root)) throw new Error('Registry araç kaydı tip sözleşmesiyle eşleşmiyor.');
}
